import { useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logoutMutation } = useAuth();
  const [location] = useLocation();

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  const getInitials = (name: string) => {
    if (!name) return "?";
    return name.split(" ").map(n => n[0]).join("").toUpperCase();
  };

  const getFirstName = (fullName: string) => {
    if (!fullName) return "";
    return fullName.split(" ")[0];
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <Link href="/">
            <h1 className="text-2xl font-heading font-bold text-primary cursor-pointer">
              Therapy Hub
            </h1>
          </Link>
        </div>
        
        <nav className="hidden md:flex space-x-6">
          <Link href="/" className={`${location === "/" ? "text-primary" : "text-dark"} hover:text-primary transition-colors`}>
            Início
          </Link>
          <Link href="/therapists" className={`${location === "/therapists" ? "text-primary" : "text-dark"} hover:text-primary transition-colors`}>
            Terapeutas
          </Link>
          <Link href="/sessions" className={`${location === "/sessions" ? "text-primary" : "text-dark"} hover:text-primary transition-colors`}>
            Minhas Sessões
          </Link>
          <Link href="/booking" className={`${location === "/booking" ? "text-primary" : "text-dark"} hover:text-primary transition-colors`}>
            Agendar
          </Link>
        </nav>
        
        <div className="flex items-center space-x-4">
          {user && (
            <div className="hidden md:block">
              <div className="relative flex items-center">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-gray-200 text-dark text-sm">
                    {getInitials(`${user.firstName} ${user.lastName}`)}
                  </AvatarFallback>
                </Avatar>
                <span className="ml-2 text-dark">{getFirstName(user.firstName)}</span>
              </div>
            </div>
          )}
          
          <div className="hidden md:block">
            {user ? (
              <Button variant="ghost" onClick={handleLogout} className="text-gray-600 hover:text-primary">
                Sair
              </Button>
            ) : (
              <Link href="/auth" asChild>
                <Button>Entrar</Button>
              </Link>
            )}
          </div>
          
          <button
            className="md:hidden text-dark p-1"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className="fas fa-bars text-xl"></i>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden container mx-auto px-4 py-3 bg-white">
          <nav className="flex flex-col space-y-3">
            <Link 
              href="/" 
              className={`${location === "/" ? "text-primary" : "text-dark"} hover:text-primary transition-colors py-2 border-b border-gray-200`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Início
            </Link>
            <Link 
              href="/therapists" 
              className={`${location === "/therapists" ? "text-primary" : "text-dark"} hover:text-primary transition-colors py-2 border-b border-gray-200`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Terapeutas
            </Link>
            <Link 
              href="/sessions" 
              className={`${location === "/sessions" ? "text-primary" : "text-dark"} hover:text-primary transition-colors py-2 border-b border-gray-200`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Minhas Sessões
            </Link>
            <Link 
              href="/booking" 
              className={`${location === "/booking" ? "text-primary" : "text-dark"} hover:text-primary transition-colors py-2 border-b border-gray-200`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Agendar
            </Link>
            
            {user && (
              <div className="flex items-center py-2 border-b border-gray-200">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-gray-200 text-dark text-sm">
                    {getInitials(`${user.firstName} ${user.lastName}`)}
                  </AvatarFallback>
                </Avatar>
                <span className="ml-2 text-dark">{user.firstName}</span>
              </div>
            )}
            
            {user ? (
              <button 
                className="text-left text-gray-600 hover:text-primary transition-colors py-2"
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                Sair
              </button>
            ) : (
              <Link href="/auth"
                className="text-primary font-medium hover:text-secondary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Entrar
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
